export default "__VITE_ASSET__da8cf2f1__"